/**
 * Pollo Kling v2.6：input 结构单独封装
 * 图生：image 必填，imageTail 可选，prompt 1-2500，length 5|10，generateAudio 默认 false
 * 文生：prompt 必填，aspectRatio 16:9|9:16|1:1，length 5|10，generateAudio
 */
import { isUrl } from './utils'

function normalizeLength(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 5
  return num === 10 ? 10 : 5
}

export function buildBody(params) {
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: (params.prompt || '').trim().slice(0, 2500),
    length: normalizeLength(params.videoDuration || params.length || 5),
    generateAudio: params.generateAudio === true
  }
  if (hasImage) {
    input.image = params.referenceImage.trim()
    if (isUrl(params.imageTail || params.endFrameImage)) input.imageTail = (params.imageTail || params.endFrameImage).trim()
  } else {
    input.aspectRatio = (params.aspectRatio || '16:9').replace(/：/g, ':')
    if (input.aspectRatio !== '16:9' && input.aspectRatio !== '9:16' && input.aspectRatio !== '1:1') input.aspectRatio = '16:9'
  }
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
